<template>
<section class="sm-list customer">
  <div class="sm-wrap">
    <div class="sm-list-inner"
      :class="checkedItems.length ? 'action' : ''"
    >
      <div
        v-if="checkedItems.length"
        class="sm-actions-table sm-list__actions"
      >
        <btn-block
          v-for="action in mailActions"
          :key="action.name"
          :type="'action'"
          :icon="action.btn.icon"
          :text="`${action.btn.groupText || action.name.charAt(0).toUpperCase() + action.name.slice(1).replace(/_/g, ' ')}`"
          @click="groupAction(action.name)"
        />
      </div>

      <template v-if="!emptyState">
        <table v-if="!isMobile" class="sm-table sm-list__table">
          <thead class="sm-table__head">
            <tr class="sm-txt-upper">
              <th
                v-if="status == 'new'"
                class="sm-table__head-item checkbox"
              >
                <checkbox-block
                  @input.native="toggleAll"
                  v-model="checkAll"
                ></checkbox-block>
              </th>
              <th
                class="sm-table__head-item number sort"
                :class="currentSort === 'mail_number' && currentSortDir === 'asc' ? 'active' : ''"
                @click="sortBy('mail_number')">
                № <include-svg :name="'icon-arrow-b-bold'" />
              </th>
              <th
                class="sm-table__head-item sender sort"
                :class="currentSort === 'sender' && currentSortDir === 'asc' ? 'active' : ''"
                @click="sortBy('sender')">
                Sender <include-svg :name="'icon-arrow-b-bold'" />
              </th>
              <th
                class="sm-table__head-item date sort"
                :class="currentSort === 'received_at' && currentSortDir === 'asc' ? 'active' : ''"
                @click="sortBy('received_at')">
                Posted Date <include-svg :name="'icon-arrow-b-bold'" />
              </th>
              <th
                class="sm-table__head-item type sort"
                :class="currentSort === 'mail_type_id' && currentSortDir === 'asc' ? 'active' : ''"
                @click="sortBy('mail_type_id')">
                Type <include-svg :name="'icon-arrow-b-bold'" />
              </th>
              <th class="sm-table__head-item qty">Qty.</th>
              <th
                class="sm-table__head-item date sort"
                :class="currentSort === 'received_at' && currentSortDir === 'asc' ? 'active' : ''"
                @click="sortBy('received_at')">
                Request Date <include-svg :name="'icon-arrow-b-bold'" />
              </th>
              <th
                class="sm-table__head-item status sort"
              >
                Status
              </th>
              <th class="sm-table__head-item request">
                <span>Request</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <item-mail
              v-for="item in mailList"
              :key="item.id"
              :mail="item"
              :status="status"
              :isApproved="isAccessFilesApproved"
              @remove-selection="removeSelection"
              @action="itemAction"
              @hide="hidePopups"
              @comment="showComment"
            ></item-mail>
          </tbody>
        </table>

        <div v-else class="sm-mobile-table sm-list__mobile">
          <div class="sm-mobile-table-item header">
            <div class="sm-mobile-table-item-row">
              <div class="sm-mobile-table-item-row-th">Sender</div>
              <div class="sm-mobile-table-item-row-th date">Posted date</div>
            </div>
          </div>
          <item-mail
            v-for="item in mailList"
            :key="item.id"
            :mail="item"
            :status="status"
            :isApproved="isAccessFilesApproved"
            @remove-selection="removeSelection"
            @action="itemAction"
            @hide="hidePopups"
            @comment="showComment"
          ></item-mail>
        </div>
      </template>
      <empty-table
        v-else
        :title="'Nothing here yet'"
        :text="emptyData[status].text"
        :icon="emptyData[status].icon"
      />

      <sm-spinner :show="statusFetch === 'requested'" />

      <paginate-block
        v-if="mailList.length"
        v-model="pager.onPage"
        :pages="pager.pages"
        :page="pager.page"
        :onPage="pager.onPage"
        :morePages="morePages"
        :items="pager.items"
        @showMore="getMoreMails()"
      />
    </div>
    <popup-block
      v-if="popup.isOpen"
      :size="popup.size"
      :open="popup.isOpen"
      class="sm-list__popup"
      @close="popup.isOpen = false"
    >
      <template slot="popupContent">
        <div
          v-if="popup.type == 'comment'"
          class="sm-list__popup-content"
        >
          <h4>Mail details #{{popup.item.mail_number}}</h4>
          <div
            v-if="popup.item.comments"
            class="sm-list__popup-content-block"
          >
            <h5>Admin comment</h5>
            <p>{{popup.item.comments}}</p>
          </div>
          <div
            v-if="popup.item.history"
            class="sm-list__popup-content-block"
          >
            <h5>Action history</h5>
            <ul>
              <li
                v-for="(item, index) in popup.item.history"
                :key="index"
              >
                <span>{{item.date}}</span>
                <span>{{item.action}}</span>
              </li>
            </ul>
          </div>
        </div>
        <form
          v-if="popup.type == 'forward' || popup.type == 'group_forward'"
          class="sm-list__popup-form"
          @submit.prevent="actionWithOptions(popup.type)"
        >
          <h4>Forwarding options</h4>
          <h5 v-if="forwardAddresses.length">Delivery option</h5>
          <div class="sm-list__popup-form-radio">
            <radiobutton-block
              v-for="(item, index) in popup.item.actionOptions.delivery_days"
              :key="index"
              v-model="curForward.delivery"
              :text="item.title"
              :name="'delivery'"
              :checked="index == 0 ? true : false"
              @input="curForward.delivery = item"
            />
          </div>
          <h5 v-if="forwardAddresses.length">Shipping address</h5>
          <dropdown-block
            v-if="forwardAddresses.length"
            v-model="curForward.address"
            class="sm-dropdown"
            :class="forwardAddresses.length > 1 ? '' : 'disabled'"
            :options="forwardAddresses"
            :placeholder="`Forwarding address`"
            :preselect-first="true"
          >
            <template slot="placeholder">
              <span>Forwarding address</span>
              <include-svg :name="'icon-arrow-b'" />
            </template>
            <template slot="singleLabel" slot-scope="props" :value="props.option.id">
              <span>{{ formatAddress(props.option) }}</span>
              <include-svg :name="'icon-arrow-b'" />
            </template>
            <template slot="noOptions">
              <span>Loading...</span>
            </template>
            <template slot="option" slot-scope="props" :value="props.option.id">
              <span class="sm-txt-capitalize">{{ formatAddress(props.option) }}</span>
            </template>
          </dropdown-block>
          <p
            v-if="provider.client_level != 1"
            class="sm-list__popup-form-note"
          >You will be charged an amount of {{formatPrice(currentForwardSurcharge)}} + postage</p>
          <btn-block
            :type="'submit'"
            :text="`Request forward ${provider.client_level != 1 ? `for ${formatPrice(currentForwardSurcharge)}`:``}`"
          />
        </form>
        <form
          v-if="popup.type == 'scan' || popup.type == 'group_scan'"
          class="sm-list__popup-form"
          @submit.prevent="actionWithOptions(popup.type)"
        >
          <h4>Scan option</h4>
          <div class="sm-list__popup-form-radio">
            <radiobutton-block
              v-for="(item, index) in popup.item.actionOptions.scan_delivery_type"
              :key="index"
              v-model="curScan"
              :text="item.title"
              :description="item.descr"
              :name="'scan'"
              :checked="index == 0 ? true : false"
              @input="curScan = item"
            />
          </div>
          <p class="sm-list__popup-form-note" v-if="provider.client_level != 1">{{scanPopupData.text}}</p>
          <btn-block
            :type="'submit'"
            :text="`Request scan ${provider.client_level != 1 ? `for ${scanPopupData.price}`:``}`"
          />
        </form>
        <form
          v-if="popup.type == 'junk' || popup.type == 'group_junk'"
          class="sm-list__popup-form"
          @submit.prevent="actionWithOptions(popup.type)"
        >
          <h4>Select a Junk Mail Option:</h4>
          <div class="sm-list__popup-form-radio junk">
            <radiobutton-block
              v-for="(item, index) in popup.item.actionOptions.trash_now.customer"
              :key="index"
              v-model="curTrash"
              :type="'sys'"
              :text="item.title"
              :description="provider.client_level != 1 ? item.descr : null"
              :name="'junk'"
              :checked="((index === 0 && !curTrash.value) || (index === 1 && curTrash.value)) ? true : false"
              @input="curTrash = item"
            />
          </div>

          <btn-block
            :type="'submit'"
            :text="`Confirm`"
          />
        </form>
        <form
          v-if="popup.type == 'picture' || popup.type == 'group_picture'"
          class="sm-list__popup-form"
          @submit.prevent="actionWithOptions(popup.type)"
        >
          <h4>Confirm envelope picture request</h4>
          <p class="sm-list__popup-form-note">You will be charged an amount of {{formatPrice(userPlan.mail_item_picture_price)}}{{popup.type == 'group_picture' ? ' per mail item' : ''}}</p>
          <btn-block
            :type="'submit'"
            :text="`Request picture for ${formatPrice(popup.type == 'picture' ? userPlan.mail_item_picture_price : (userPlan.mail_item_picture_price * checkedItems.length))}`"
          />
        </form>
        <form 
          v-if="popup.type == 'mark_as_pick_up' || popup.type == 'check_deposit'"
          class="sm-list__popup-form"
          @submit.prevent="proceedActionWithoutOptions(item)"
        >
          <h4>{{popup.title}} Request</h4>

          <p 
            v-if="provider.client_level != 1"
            class="sm-list__popup-form-note"
          >You will be charged an amount of {{actionWithOptionsPrice(popup.type)}}</p>
          <btn-block
            :type="'submit'"
            :text="`Request ${popup.title} ${provider.client_level != 1 ? `for ${actionWithOptionsPrice(popup.type)}`:``}`"
          />
        </form>


        <form
          v-if="popup.type == 'shred'"
          class="sm-list__popup-form"
          @submit.prevent="actionWithOptions(popup.type)"
        >
          <h4>Shred Request</h4>
          <p class="sm-list__popup-form-note" v-if="provider.client_level != 1">{{shredPopupData.text}}</p>
          <btn-block
            :type="'submit'"
            :text="`Request shred ${provider.client_level != 1 ? `for ${shredPopupData.price}`:``}`"
          />
        </form>


        <div 
          v-if="popup.type == 'notarize'"
          class="sm-list__popup-content"
        >
          <include-svg :name="'icon-warning'" />
          <h4 class="sm-txt-center">Please sign USPS Form 1583 to continue</h4>
          <p>We can't process your request until USPS Form 1583 is completed and notarized.</p>
          <p>Click the button to notarize the form online.</p>
          <btn-block
            :text="`Notarize`"
            @click="openNotaryService"
          />
        </div>
        <additional-services
          v-if="popup.type == 'add_services'"
          @subscribe="subscribeToAddServiceSuccess"
        />
        <div
          v-if="popup.type == 'add_success'"
          class="sm-list__popup-content add-service-success"
        >
          <h4 class="sm-txt-center">SpherePhone Live Receptionist "{{popup.text}}" successfully activated</h4>
          <btn-block
            :text="'Show more extras'"
            @click="$router.push('account?tab=phone')"
          />
        </div>
        <div
          v-if="popup.type == 'no-documents'"
          class="sm-list__popup-content"
        >
          <template v-if="!allDocumentsProvided">
            <include-svg :name="'icon-warning'" />
            <h4 class="sm-txt-center">Please provide all required documents</h4>
            <p>We can’t process your request until all required documents are provided.</p>
            <p>You can see the list of required documents in you account settings</p>
            <btn-block
              :text="`Go to Account`"
              @click="$router.push('account?notarize=1')"
            />
          </template>
          <template v-else>
            <include-svg :name="'icon-awaiting'" />
            <h4 class="sm-txt-center">Please wait until administrator approve your documents</h4>
            <p>We can’t process your request until all required documents are approved by your administrator.</p>
            <p>You can see the list and statuses of required documents in you account settings</p>
            <btn-block
              :text="`Go to Account`"
              @click="$router.push('account?notarize=1')"
            />
          </template>
        </div>
        <schedule-pickup
          v-if="popup.type == 'pick_up' || popup.type == 'group_pick_up'"
          :pickUpSettings="pickUpSettings"
          :btnText="`Request pick up ${provider.client_level != 1 ? `for ${formatPrice(userPlan['price_per_pickup'])}`:``}`"
          @submit="handleSchedulePickup"
        />
      </template>
    </popup-block>
  </div>

  <mail-action />
</section>

</template>
<script>
import ItemMail from '@/views/customer/pages/mail/components/ItemMail';
import PaginateBlock from '@/components/PaginateBlock';
import Popup from '@/components/Popup';
import Btn from '@/components/Buttons';
import Checkbox from '@/components/Checkboxes';
import Spinner from '@/components/Spinner';
import MailParams from '@/settings/mail';
import { mapActions, mapGetters } from 'vuex';
import Hint from '@/components/Hint';
import Radiobutton from '@/components/Radiobutton';
import MailAction from '@/views/customer/pages/mail/components/MailAction';
import Multiselect from 'vue-multiselect';
import SchedulePickup from '@/views/customer/pages/mail/components/SchedulePickup';
import { FormatPrice } from '@/utils/general-data';
import EmptyTable from '@/components/EmptyTable';
import AdditionalServices from '@/views/page-elements/AdditionalServices';


export default {
  name: 'mail-list',
  components: {
    'item-mail': ItemMail,
    'btn-block': Btn,
    'checkbox-block': Checkbox,
    'paginate-block': PaginateBlock,
    'popup-block': Popup,
    'hint-block': Hint,
    'sm-spinner': Spinner,
    'radiobutton-block': Radiobutton,
    'dropdown-block': Multiselect,
    'empty-table': EmptyTable,
    'mail-action': MailAction,
    'additional-services': AdditionalServices,
    'schedule-pickup': SchedulePickup
  },
  data() {
    return {
      prepareList: [],
      prepareMoreList: [],
      morePages: 0,
      checkAll: false,
      key: '',
      currentSort: 'id',
      currentSortDir: 'desc',
      pager: {
        page: 1,
        pages: 1,
        items: 1,
        onPage: 8
      },
      emptyState: false,
      availableActions: ['check_deposit', 'picture', 'scan', 'forward', 'pick_up', 'mark_as_pick_up', 'shred', 'junk'],
      actionList: [],
      popup: {
        isOpen: false,
        type: '', // values: comment, forward, group_forward, scan, group_scan, notarize, add_services, add_success, no-documents
        title:"",
        item: {},
        params:{}
      },
      curForward: {
        delivery: '',
        address: ''
      },
      forwardAddresses: [],
      curScan: '',
      curTrash: null,
      emptyData: {
        new: {
          text: 'All incoming mail displayed here',
          icon: 'icon-empty-new'
        },
        pending: {
          text: 'Mail items which are pending displayed here',
          icon: 'icon-empty-pending'
        },
        processed: {
          text: 'Mail items with completed requests displayed here',
          icon: 'icon-empty-processed'
        },
        junk: {
          text: 'Mail items which you marked as junk displayed here',
          icon: 'icon-empty-junk'
        },
        all: {
          text: 'All your mail displayed here',
          icon: 'icon-empty-new'
        }
      },
      freeScanBalance: 0,
      freeShredBalance: 0,
      clientFeatures: {},
      pickUpSettings: [],
      selectedPickUpTime: ''
    }
  },
  created() {
    Promise.all([
      this.getFwdAddrList(),
      this.getUserPlan(true),
      this.getUserAccount(),
      this.getCountryList(),
      this.getCurrentActivity(),
      this.getClientFeatures()
    ])
      .then(([fwdList, plan, acc, countries, stats, features]) => {
        this.forwardAddresses = fwdList.forward_addresses;
        this.curForward.address = this.forwardAddresses[0];
        this.clientFeatures = features;

        let query = Object.assign({}, this.$route.query);
        if (query.select_phone) {
          delete query.select_phone;
          this.$router.replace({ query });
          this.showAddServices();
        } else {
          if (query.order) {
            let orderObj = JSON.parse(decodeURIComponent(query.order));
            if (orderObj.column)
              this.currentSort = orderObj.column;
            if (orderObj.direction)
              this.currentSort = orderObj.direction;
          }
          if (this.isMobile && (query.page || query.limit)) {
            delete query.page;
            delete query.limit;

            this.$router.replace({ query });
          }
          if (query.page)
            this.pager.page = parseInt(query.page);
          if (query.limit)
            this.pager.onPage = parseInt(query.limit);
        }

        

        if (stats && stats.hasOwnProperty('shred') && this.userPlan && this.userPlan.complimentary_shreds)
          this.freeShredBalance = this.userPlan.complimentary_shreds - stats.shred;



        if (stats && stats.hasOwnProperty('standard_scans') && this.userPlan && this.userPlan.complimentary_scans)
          this.freeScanBalance = this.userPlan.complimentary_scans - stats.standard_scans;

        this.updatemailList(query);

        if (this.provider.pick_up_scheduling_enabled)
          this.getPickUpSettings()
            .then(res => {
              this.pickUpSettings = res.settings;
            });
      });
  },
  computed: {
    ...mapGetters({
      isMobile: 'isMobile',
      list: 'mail/list',
      more: 'mail/more',
      statusFetch: 'mail/status',
      actionMail: 'mail/actionMail',
      countryList: 'countryList',
      userAccount: 'account/userAccount',
      userPlan: 'account/userPlan',
      provider: 'provider',
      form1583Signed: 'account/form1583Signed'
    }),
    mailList() {
      return [...this.prepareList, ...this.prepareMoreList];
    },
    checkedItems() {
      return this.mailList.filter(item => item.active == true);
    },
    status() {
      return this.$route.query.status || 'new';
    },
    mailActions() {
      let res = {};

      this.availableActions.forEach(action => {
        if (!this.checkedItems.some(item => this.checkItemRestrictions(item, MailParams.actions[action])))
          res[action] = MailParams.actions[action];
      });

      return res;
    },
    scanPopupData() {
      if (!this.curScan || !this.popup.type.includes('scan'))
        return {};

      if (this.curScan.name == 'standard_scan' && this.freeScanBalance) {
        if (this.popup.type == 'scan') {
          return {
            text: `Free of charge (${this.freeScanBalance} free scan${this.freeScanBalance > 1 ? 's' : ''} left)`,
            price: this.formatPrice(0)
          }
        } else {// group-scan
          if (this.checkedItems.length <= this.freeScanBalance) {
            return {
              text: `Free of charge (${this.freeScanBalance} free scan${this.freeScanBalance > 1 ? 's' : ''} left)`,
              price: this.formatPrice(0)
            }
          } else {
            return {
              text: `${this.freeScanBalance} free scan${this.freeScanBalance > 1 ? 's' : ''} and ${this.formatPrice(this.userPlan[this.curScan.price_field])} for every additional`,
              price: this.formatPrice(this.userPlan[this.curScan.price_field] * (this.checkedItems.length - this.freeScanBalance))
            }
          }
        }
      } else {
        if (this.popup.type == 'scan')
          return {
            text: `You will be charged an amount of ${this.formatPrice(this.userPlan[this.curScan.price_field])}`,
            price: this.formatPrice(this.userPlan[this.curScan.price_field])
          }
        else // group-scan
          return {
            text: `You will be charged an amount of ${this.formatPrice(this.userPlan[this.curScan.price_field])} per scan`,
            price: this.formatPrice(this.userPlan[this.curScan.price_field] * this.checkedItems.length)
          }
      }
    },
    shredPopupData() {
      if (!this.popup.type.includes('shred'))
        return {};


      if (this.freeShredBalance) {
          return {
            text: `Free of charge (${this.freeShredBalance} free shred${this.freeShredBalance > 1 ? 's' : ''} left)`,
            price: this.formatPrice(0)
          }
      } else {
        return {
          text: `You will be charged an amount of ${this.formatPrice(this.userPlan["price_per_shred"])}`,
          price: this.formatPrice(this.userPlan["price_per_shred"])
        }
      }
      
    },
    currentForwardSurcharge() {
      if (
        !this.curForward.delivery ||
        !this.curForward.address ||
        !this.popup.type.includes('forward') ||
        !this.popup.item
      )
        return 0;

      let isLocal = this.provider.country_id == this.curForward.address.country_id;
      let isExpedited = this.curForward.delivery.days > 0;

      let surchargeField = '';
      let amount = 0;

      if (this.popup.type == 'group_forward') {
        surchargeField = 'groupmail_forward';
      } else if (this.popup.item.type == 'package') {
        surchargeField = 'forward_package_surcharge';
      } else {
        surchargeField = 'forward_surcharge';
      }

      if (isLocal || !this.userPlan[`int_${surchargeField}`]) {
        amount = this.userPlan[surchargeField];
      } else {
        amount = this.userPlan[`int_${surchargeField}`];
      }

      if (isExpedited)
        amount = amount + this.userPlan.price_per_expedited_forward;

      return amount;
    },
    isAccessFilesApproved(){
      return this.userAccount.is_form_1583_signed || (
        this.provider.country_id != 1 &&
        this.userAccount.hasOwnProperty('account_approval_status') &&
        this.userAccount.account_approval_status == 'approved'
      ) 
    },
    noDocuments() {
      return (
        this.provider.country_id != 1 &&
        this.userAccount.hasOwnProperty('account_approval_status') &&
        this.userAccount.account_approval_status != 'approved'
      )
    },
    allDocumentsProvided() {
      if (!this.userAccount.documents)
        return true;

      return !this.userAccount.documents.some(item => item.required && !item.file_url);
    }
  },
  methods: {
    ...mapActions({
      fetchMails: 'mail/fetchMails',
      fetchMore: 'mail/fetchMore',
      mailAction: 'mail/mailAction',
      groupMailAction: 'mail/groupMailAction',
      getCountryList: 'getCountryList',
      getFwdAddrList: 'account/getFwdAddrList',
      getUserPlan: 'account/getUserPlan',
      getUserAccount: 'account/userData',
      getCurrentActivity: 'account/getCurrentActivity',
      getClientFeatures: 'general/getClientFeatures',
      getPickUpSettings: 'general/getPickUpSettings'
    }),
    formatPrice: FormatPrice,
    sortBy(key) {
      if (key === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'desc' ? 'asc' : 'desc';
      } else {
        this.currentSortDir = 'desc';
      }
      this.currentSort = key;

      let orderObj = {
        column: this.currentSort,
        direction: this.currentSortDir
      };
      let router = this.$route;
      this.$router.push({
        query: {
          ...router.query,
          ...{
            order: encodeURIComponent(JSON.stringify(orderObj))
          }
        }
      });
    },
    updatemailList(val) {
      this.morePages = 0;
      let query = Object.assign({}, val);
      if (query.order)
        query.order = JSON.parse(decodeURIComponent(query.order));
      if (query.page && (parseInt(query.page) > this.list.total_pages || !this.list.total_pages))
        query.page = 1;

      this.fetchMails(query);
    },
    getMoreMails() {
      this.checkAll = false;
      this.morePages++;
      let query = Object.assign({}, this.$route.query);
      query.page = this.pager.page + this.morePages;
      query.limit = this.pager.onPage;

      if (query.order)
        query.order = JSON.parse(decodeURIComponent(query.order));
      this.fetchMore(query);
    },
    removeSelection() {
      this.checkAll = false;
    },
    toggleAll() {
      this.checkAll = !this.checkAll;
      if (this.checkAll) {
        this.mailList.forEach(item => item.active = true);
      } else {
        this.mailList.forEach(item => item.active = false);
      }
    },
    hidePopups() {
      this.mailList.forEach(item => item.popupOpen = false);
    },
    toggleItem(item) {
      item.itemOpen = !item.itemOpen;
    },
    prepareMails(mail) {
      return mail.map((item) => {
        const temp = {...item};
        temp.actionStatus = this.parseActionStatus(item);
        temp.active = false;//this.activeMails.includes(temp.id);
        temp.popupOpen = false;
        temp.itemOpen = false;

        return temp;
      });
    },
    parseActionStatus(item) {
      let status = {};
      status.active = this.status == 'pending' || this.status == 'junk' || (this.status == 'all' && (item.trashed_date || item.status_label.includes('Trash requested')));
      // status.active = item.status == 'pending' || item.status == 'junk'; // Active status means that action in progress and status can be reverted to 'new'

      if (status.active) {
        if (this.status == 'pending') { // some action in progress, find which one
          let actionInProgress = this.availableActions.find(action => {
            let actionData = MailParams.actions[action].data;

            if (item[actionData.pending.field] && !item[actionData.processed.field])
              return true;

            if (actionData.pending.alt_fields)
              return actionData.pending.alt_fields.find(field => {
                return item[field];
              });

            return false;//item[actionData.pending.field];
          });

          if (!actionInProgress) // Something wrong with data
            actionInProgress = 'default';

          status.action = {
            name: actionInProgress,
            link: {
              text: 'Cancel request'
            },
            hint: MailParams.actions[actionInProgress].cancelText,
            showHint: false
          };
        } else { // Junk

          status.actions = [
            {
              name: 'junk',
              btn: {
                icon: 'icon-action-trash',
                text: MailParams.actions['junk'].trashText
              },
              hint: MailParams.actions['junk'].trashText,
              showHint: false,
              enabled: true,
              trash_now: true,
            },
            {
              name: 'junk',
              btn: {
                icon: 'icon-action-revert-spam',
                text: MailParams.actions['junk'].cancelText
              },
              hint: MailParams.actions['junk'].cancelText,
              showHint: false,
              enabled: false,
              trash_now: false,
            },
          ];

          if (this.$moment(item.trashed_date) <= this.$moment() || item.status_label.includes('Trash requested')) {
            status.actions.shift();
          }
        }
      } else { // New or Processed
        status.actions = [];
        this.availableActions.forEach(action => {

          let actionData = MailParams.actions[action];
          status.actions.push({
            name: action,
            processed: item[actionData.data.processed.field] ? actionData.data.processed.text : false,
            btn: actionData.btn,
            result: actionData.data.result || null,
            restriction: this.checkItemRestrictions(item, actionData),
            showHint: false
          });
        });
      }
      return status;
    },
    itemAction({item, action, enabled, trashNow}) {
      if (this.provider.client_level != 1) {
        if (this.provider.country_id == 1 && !this.userAccount.is_form_1583_signed) {
          this.popup.type = 'notarize';
          this.popup.isOpen = true;
          return;
        } else if (this.noDocuments) {
          this.popup.type = 'no-documents';
          this.popup.isOpen = true;
          return;
        }
      }
      if (!enabled || !MailParams.actions[action].options || this.checkOptionsDisabled(MailParams.actions[action]) || (trashNow && (item.trashed_date || item.stauts_label.includes('Trash requested')))) {
        let params = {
          id: item.id,
          action: action,
          enabled: enabled
        }

        if(action.includes('junk'))
          params.options = { 'options[trash_now]': trashNow};

        

        if(enabled){
          switch(action){
            case "shred":
              this.popup.title = "Shred";
              break;
            case "mark_as_pick_up":
              this.popup.title = "Mark as picked up";
              break;
            case "check_deposit":
              this.popup.title = "Check deposit";
              break;
            default:
              this.popup.title = "";
          }
          this.popup.params = params
          this.openActionPopup(action, item)
        }else {
          this.mailAction(params);
        }
        

      } else {
        this.proceedActionWithOptions(item, action, false);
      }
    },
    groupAction(action) {
      if (this.provider.country_id == 1 && !this.userAccount.is_form_1583_signed) {
        this.popup.type = 'notarize';
        this.popup.isOpen = true;
        return;
      } else if (this.noDocuments) {
        this.popup.type = 'no-documents';
        this.popup.isOpen = true;
        return;
      }

      if (!MailParams.actions[action].options || this.checkOptionsDisabled(MailParams.actions[action])) {
        let ids = [];
        this.checkedItems.forEach(item => {
          ids.push(item.id);
        });
        let params = {
          action,
          toSend: {
            enabled: true,
            ids
          }
        };
        this.groupMailAction(params);
      } else {
        this.proceedActionWithOptions(this.checkedItems[0], action, true);
      }
    },
    actionWithOptions(action, id) {
      let options = {};

      if (action.includes('forward')) {
        options.forward_address_id = this.curForward.address.id;

        if (this.curForward.delivery.days/* && this.curForward.delivery.days != 3*/) // 1, 2 or 3 days - expedited fwd
          options.delivery_days = this.curForward.delivery.days;
      }

      if (action.includes('scan')) {
        options.scan_delivery_type = this.curScan.name;

        if (this.curScan.name == 'standard_scan' && this.freeScanBalance) {
          if (action == 'scan') {
            this.freeScanBalance--;
          } else { // group-scan
            this.freeScanBalance = this.freeScanBalance - this.checkedItems.length;

            if (this.freeScanBalance < 0)
              this.freeScanBalance = 0;
          }
        }
      }

      if (action.includes('junk')) {
        options.trash_now = this.curTrash.value;
      }

      if (action == 'pick_up' || action == 'group_pick_up') {
        options.pick_up_scheduled_at = this.selectedPickUpTime;
      }

      if (!action.includes('group')) {
        let params = {
          id: id || this.popup.item.id,
          enabled: true,
          action,
          //options
        };

        if (Object.keys(options).length)
          params.options = {
            options
          };

        this.mailAction(params);
      } else {
        let ids = [];
        this.checkedItems.forEach(item => {
          ids.push(item.id);
        });

        let params = {
          action: action.split('group_')[1],
          toSend: {
            enabled: true,
            ids,
            options
          }
        };

        this.groupMailAction(params);
      }

      this.popup.isOpen = false;
    },
    formatAddress(item) {
      let res = '';

      if (item.street)
        res += `${item.street}, `;

      if (item.city)
        res += `${item.city}, `;

      if (item.zip_code)
        res += `${item.zip_code}, `;

      if (item.country_id) {
        let addrCountry = this.countryList.find(country => country.id == item.country_id);
        res += addrCountry.code;
      }

      return res;
    },
    proceedActionWithoutOptions(){
        this.mailAction(this.popup.params);
        this.popup.isOpen = false;
    },
    proceedActionWithOptions(item, action, isGroup) {
      let type = isGroup ? `group_${action}` : action;

      if (action == 'scan') {
        item.actionOptions = {
          scan_delivery_type: this.getScanDeliveryDays(MailParams.actions[action].options)
        };
        this.curScan = item.actionOptions.scan_delivery_type[0];
      }

      if (action == 'forward') {
        item.actionOptions = MailParams.actions[action].options;
        this.curForward.delivery = item.actionOptions.delivery_days[0];
      }

      if (action == 'picture' && this.provider.client_level == 1) {
        this.actionWithOptions(type, item.id);
        return;
      }

      if (action == 'pick_up') {
        this.popup.size = 'medium';
      }

      if (action == 'junk') {
        item.actionOptions = MailParams.actions[action].options;

        this.curTrash = item.actionOptions.trash_now.customer[0];
      }

      this.openActionPopup(type, item);
    },
    openActionPopup(type, item) {
      this.popup.type = type;
      this.popup.item = item;
      this.popup.isOpen = true;
    },
    checkOptionsDisabled(action) {
      if (!action.options)
        return true;

      if (
        action.planOptionsDisableField &&
        this.userPlan.hasOwnProperty(action.planOptionsDisableField) &&
        !this.userPlan[action.planOptionsDisableField]
      )
        return true;

      if (
        action.clientOptionsDisableField &&
        this.provider.hasOwnProperty(action.clientOptionsDisableField) &&
        !this.provider[action.clientOptionsDisableField]
      )
        return true;

      if (
        action.name == 'pick_up' &&
        (
          !this.pickUpSettings.length ||
          this.pickUpSettings.every(item => !item.enabled)
        )
      )
        return true;

      return false;
    },
    getScanDeliveryDays(options) {
      return options.scan_delivery_type.filter(option => {
        if (option.name != 'standard_scan' && !this.userPlan.expedited_scan_service_enabled)
          return false;

        return true;
      })
    },
    checkItemRestrictions(item, actionData) {
      if (actionData.data.conditions) {
        let res = false;

        if (actionData.data.conditions.plan) {
          res = actionData.data.conditions.plan.find(plan => {
            if (this.userPlan.hasOwnProperty(plan.field) &&
                !this.userPlan[plan.field])
              return plan;
          });

          if (res)
            return res.text;
        }

        if (actionData.data.conditions.item) {
          // res = actionData.data.conditions.item.find(_item => !item[_item.field]);
          res = actionData.data.conditions.item.find(_item => {
            if (!_item.onlyAdmin) {
              if (_item.not) return item[_item.field];
              else return !item[_item.field];
            }
          });
          if (res)
            return res.text;
        }

        if (actionData.data.conditions.local) {
          res = actionData.data.conditions.local.find(_item => !this[_item.field] || !this[_item.field].length);

          if (res)
            return res.text;
        }
      }

      let processedAction = MailParams.nonRevertableActions.find(action => item[MailParams.actions[action].data.processed.field]);

      if (processedAction && actionData.name != processedAction)
        return `Can't process action, item is ${MailParams.actions[processedAction].data.processed.text}`;

      if (this.provider.client_level == 1 && this.clientFeatures) {
        if (actionData.name == 'forward' && !this.clientFeatures.has_mail_forward)
          return 'Mail Forward is disabled';

        if (actionData.name == 'scan' && !this.clientFeatures.has_mail_scan)
          return 'Mail Scan is disabled';
      }

      return false;
    },
    actionWithOptionsPrice(action) {
      if(action == "shred"){
        return this.formatPrice(this.userPlan['price_per_shred'])
      }else if(action == "mark_as_pick_up"){
        return this.formatPrice(this.userPlan['price_per_pickup'])
      }else if(action == "check_deposit"){
        return this.formatPrice(this.userPlan['check_deposit_service_price'])
      }else{
        return "$0.00";
      }
    },
    showComment(item) {
      this.popup.type = 'comment';
      this.popup.item = item;
      this.popup.isOpen = true;
    },
    showAddServices() {
      this.popup.type = 'add_services';
      this.popup.size = 'xlarge';
      this.popup.isOpen = true;
    },
    subscribeToAddServiceSuccess(text) {
      this.popup.text = text;
      this.popup.type = 'add_success';
      this.popup.size = 'medium';
    },
    openNotaryService() {
      // window.open(Urls.external.notary_service, '_blank', {width: '100%'});
      this.$router.push('account?notarize=1');
    },
    handleSchedulePickup(data) {
      this.selectedPickUpTime = data;
      this.actionWithOptions(this.popup.type, this.popup.item.id);
      this.popup.isOpen = false;
    }
  },
  watch: {
    list() {
      this.checkAll = false;
      this.pager.page = this.list.page;
      this.pager.pages = this.list.total_pages;
      this.pager.items = this.list.total_count;
      this.pager.onPage = parseInt(this.$route.query.limit) || 8;
      if (!this.$route.query.order) {
        this.currentSort = 'id';
        this.currentSortDir = 'desc';
      }
      this.emptyState = this.list.mail_items.length == 0;
      this.prepareList = this.prepareMails(this.list.mail_items);
    },
    more() {
      this.prepareMoreList = this.prepareMails(this.more);
    },
    '$route.query'(val) {
      if (val.limit)
        this.pager.onPage = parseInt(val.limit);

      this.updatemailList(val);
    },
    actionMail() {
      this.updatemailList(this.$route.query);
    },
    'popup.isOpen'(val) {
      if (val === false)
        this.popup.size = '';
    }
  }
}
</script>

<style lang="scss">
  @use '@/assets/scss/general/mixins.scss' as *;
  @use '@/assets/scss/framework/scss-variables.scss' as *;
  @use '@/assets/scss/pages/common/mail/_list.scss';
  .hintFade-enter,
  .hintFade-leave-to {
    opacity: 0;
  }
  .hintFade-enter-active {
    transition: opacity .2s;
  }
</style>
